// App
import { App } from "@js/app";

import "virtual:svg-icons-register";
// Styles
import "@styles/style.scss";

const app = new App();
app.init();
